import {
  CREATECHANELPARTNER,
  GETCHANELPARTNER,
  UPDATECHANELPARTNER,
  DELETECHANELPARTNER,
  GETCHANELPARTNERMAPPING,
  CREATECHANELPARTNERMAPPING,
  UPDATECHANELPARTNERMAPPING,
  DELETECHANELPARTNERMAPPING,
  CREATE_CHANNEL_PARTNER_DOC,
  UPDATE_CHANNEL_PARTNER_DOC,
  GET_CHANNEL_PARTNER_DOC,
  DELETE_CHANNEL_PARTNER_DOC,
  GET_CHANNEL_PARTNER_PAYOUT_ALL,
  GET_CHANNEL_PARTNER_PAYOUT_BALANCE,
  GET_CHANNEL_PARTNER_COMMISSION_LOG,
  GET_CHANNEL_PARTNER_CONTACT_ALL,
  axios,
  baseURL,
} from "./types";

export const createChanelPartner = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartner/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECHANELPARTNER,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChanelPartner = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartner/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHANELPARTNER,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const updateChanelPartner = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupchannelpartner/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATECHANELPARTNER,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const deleteChanelPartner = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupchannelpartner/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETECHANELPARTNER,
        payload: response.data,
        partner_id: data.partner_id,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChanelPartnerMapping = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartnermapping/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GETCHANELPARTNERMAPPING,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const createChanelPartnerMapping = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartnermapping/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATECHANELPARTNERMAPPING,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const updateChanelPartnerMapping = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupchannelpartnermapping/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATECHANELPARTNERMAPPING,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const deleteChanelPartnerMapping = (data) => (dispatch) => {
  var config = {
    method: "delete",
    url: baseURL + "/api/setupchannelpartnermapping/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: DELETECHANELPARTNERMAPPING,
        payload: response.data,
        mapping_id: data.mapping_id,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const createChannelPartnerDoc = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartnerdoc/create",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: CREATE_CHANNEL_PARTNER_DOC,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const updateChannelPartnerDoc = (data) => (dispatch) => {
  var config = {
    method: "patch",
    url: baseURL + "/api/setupchannelpartnerdoc/update",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "multipart/form-data",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: UPDATE_CHANNEL_PARTNER_DOC,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChannelPartnerDoc = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupchannelpartnerdoc/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_CHANNEL_PARTNER_DOC,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const deleteChannelPartnerDoc = (data) => (dispatch) => {
  const docData = typeof data === "string" ? JSON.parse(data) : data;

  var config = {
    method: "delete",
    url: baseURL + "/api/setupchannelpartnerdoc/delete",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: "DELETE_CHANNEL_PARTNER_DOC",
        payload: response.data,
        docId: docData.id,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};
export const getChannelPartnerPayoutAll = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/channelpartnerpayout/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_CHANNEL_PARTNER_PAYOUT_ALL,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChannelPartnerPayoutBalance = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/channelpartnerpayout/getbalance",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_CHANNEL_PARTNER_PAYOUT_BALANCE,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChannelPartnerCommissionLog = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/channelpartnercommissionlog",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_CHANNEL_PARTNER_COMMISSION_LOG,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};

export const getChannelPartnerContactAll = (data) => (dispatch) => {
  var config = {
    method: "post",
    url: baseURL + "/api/setupcontact/getall",
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "Content-Type": "application/json",
    },
    data: data,
  };

  return axios(config)
    .then(function (response) {
      dispatch({
        type: GET_CHANNEL_PARTNER_CONTACT_ALL,
        payload: response.data,
      });
      return response;
    })
    .catch(function (error) {
      console.log(error);
      throw error;
    });
};